import React from "react";
import PropTypes from "prop-types";
import AddBurgerForm from "./AddBurgerForm";
import EditBurgerForm from "./EditBurgerForm";
import firebase from "firebase/app";
class MenuAdmin extends React.Component {
  state = {
    photo: "",
    user: "",
  };
  static propTypes = {
    burgers: PropTypes.object,
    deleteburger: PropTypes.func,
    updateburger: PropTypes.func,
    addBurger: PropTypes.func,
    loadSampleBurgers: PropTypes.func,
  };
  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.authHandler({ user });
      }
    });
  }
  authHandler = async (authDate) => {
    const { email, photoURL } = authDate.user;
    this.setState({ user: email, photo: photoURL });
  };
  render() {
    const { user, photo } = this.state;
    const avatar = photo ? photo : "/images/avatar.png";
    return (
      <div className="Menu-admin">
        {user ? (
          <div className="login-header">
            <div className="avatar">
              <img src={avatar} alt={user} />
            </div>
            <button onClick={this.props.handleLogout} className="buttonLogout">
              Выйти
            </button>
          </div>
        ) : null}
        <h2>Управление Меню</h2>
        {Object.keys(this.props.burgers).map((key) => {
          return (
            <EditBurgerForm
              deleteBurger={this.props.deleteBurger}
              index={key}
              key={key}
              burger={this.props.burgers[key]}
              updateBurger={this.props.updateBurger}
            />
          );
        })}
        <AddBurgerForm addBurger={this.props.addBurger} />
        <button onClick={this.props.loadSampleBurgers}>
          Загрузить бургеры
        </button>
      </div>
    );
  }
}
export default MenuAdmin;
